'use client';

let IMAGE_OPTIMIZATION_API_FROM_CORE = null;

try {
  // Try to require the module if it exists.
  const coreImageOptimization = require('@eliadmin/core/next-images-optimization-api-url');
  IMAGE_OPTIMIZATION_API_FROM_CORE = coreImageOptimization.IMAGE_OPTIMIZATION_API_FROM_CORE;
} catch (error) {
  console.error('Module @eliadmin/core/next-images-optimization-api-url not found:', error);
  IMAGE_OPTIMIZATION_API_FROM_CORE = null; // Fallback in case the module is not available.
}

export default function myImageLoader({ src, width, quality }) {
  const isLocal = !src.startsWith('http');
  const query = new URLSearchParams();

  const imageOptimizationApi =
    process.env.IMAGE_OPTIMIZATION_API ??
    IMAGE_OPTIMIZATION_API_FROM_CORE ??
    'https://eliadmin.b-cdn.net/image';

  const baseUrl = process.env.NEXT_PUBLIC_APP_URL;

  const fullSrc = `${baseUrl}${src}`;

  if (width) query.set('width', width);
  query.set('quality', quality || 75);

  if (isLocal && process.env.NODE_ENV === 'development') {
    return src;
  }

  const url = `${imageOptimizationApi}/${isLocal ? fullSrc : src}`;
  const [path, hash] = url.split('#', 2);
  const params = query.toString();
  return `${path}${path.includes('?') ? '&' : '?'}${params}${hash ? `#${hash}` : ''}`;
}
